
import React, { useState, useEffect } from 'react';
import { Challenge } from '../types/game';
import { AlertCircle } from "lucide-react";

interface ChallengeEventProps {
  challenge: Challenge;
}

const ChallengeEvent: React.FC<ChallengeEventProps> = ({ challenge }) => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    setVisible(true);
    
    const timer = setTimeout(() => {
      setVisible(false);
    }, 8000);
    
    return () => clearTimeout(timer);
  }, [challenge]);
  
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div 
        className={`bg-bitcoin-primary text-white p-4 rounded-md shadow-lg flex items-center max-w-md transition-all duration-500 ease-in-out ${
          visible 
            ? 'opacity-100 translate-x-0' 
            : 'opacity-0 translate-x-full'
        }`}
      >
        <AlertCircle className="h-5 w-5 mr-3 flex-shrink-0 animate-pulse" />
        <div>
          <h3 className="font-medium mb-1">{challenge.title}</h3>
          <p className="text-sm text-white/80">Difficulty: {Array(challenge.difficulty).fill('★').join('')}</p>
        </div>
      </div>
    </div>
  );
};

export default ChallengeEvent;
